import React, { useState, useEffect } from 'react';

export default function AnimatedLoader({isOpen, loadingText}) {
  const [isVisible, setIsVisible] = useState();
  const [transition, setTransition] = useState({ opacity: '0'});

  useEffect(() => {
    let timeoutId;

    if (isOpen) {
      setIsVisible(true);
      timeoutId = setTimeout(() => {
        setTransition({ opacity: '1' });
      }, 10);
    } else {
      setTransition({ opacity: '0' });
      timeoutId = setTimeout(() => {
        setIsVisible(false);
      }, 800);
    }
    return () => clearTimeout(timeoutId);
  }, [isOpen]);

  if(isVisible){
    return (
        <div>
        <div className="loader-overlay-animated" style={{display:"flex", alignItems:"center", flexDirection:"column"}}>
        <div className="animatedloader"></div>

      <div><h3>{loadingText ? loadingText :""}</h3></div>
      </div>
      </div>
    );
  }
  else{
    return null
  }
}
